package com.ilussobsa.views

import com.ilussobsa.*
import com.ilussobsa.Strings
import com.ilussobsa.sdk.currentSession
import com.ilussobsa.sdk.currentUserSession
import com.lightningkite.UUID
import com.lightningkite.kiteui.*
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.*
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*

@Routable("upload-vehicle/{vehicleId}/images")

class TakeNewVehicleImagesScreen(val vehicleId: UUID = nullUuid) : Page {

    private val vin = Signal("")
    override fun ViewWriter.render() = frame {
        centered - card - col {
            h1("VIN:")
            sizeConstraints(width = 30.rem) - fieldTheme - textField {
                hint = vinFormat.map { it.first() }.joinToString("")
                content bind vin
            }
            row {
                expanding- space()
                WarningSemantic.plus(ButtonSemantic).onNext -button {
                    text(Strings.create)
                    ::enabled { vin().isValidVin() }
                    onClick {
                        try {
                            val result = currentUserSession().vehicle.insert(
                                Vehicle(
                                    vin = vin(),
                                )
                            )() ?: return@onClick
                            pageNavigator.replace(EditVehicleScreen(result._id))
                        } catch (e: Exception) {
                            alert(Strings.error, Strings.thereWasAnErrorCreatingTheVehicle)
                        }
                    }
                }
            }
        }
    }
}